import axios from './axios';

export default class SectionProgress {
  static update(tenantId, sectionProgressId, params) {
    return axios.put(`/paths/section_progresses/${sectionProgressId}`, params).then(response => response.data);
  }
}
